export class UnidadeProdutoRelatorioFiltrosDTO {
  idsUnidades: number[];
  idsProdutos: number[];
}